import { render, staticRenderFns } from "./AiRobot.vue?vue&type=template&id=221f5d7f&"
import script from "./AiRobot.vue?vue&type=script&lang=js&"
export * from "./AiRobot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports